



































































































import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue'
import { ContactAnonModule } from '@/store/modules/contactAnon';
import { AppModule } from '@/store/modules/app';
import ContactInterviewConfirmationConfirmDecline from '@/components/AnonContacts/ContactInterviewConfirmationConfirmDecline.vue';
import AnonJobWorkerInterviewDto from '@/models/AnonJobWorkers/AnonJobWorkerInterviewDto';
import JobWorkerInterviewType from '@/models/JobWorkerInterviews/JobWorkerInterviewType';

@Component({
  name: 'InterviewConfirmation',
  components: { ContactInterviewConfirmationConfirmDecline }
})
export default class InterviewConfirmation extends GiganautVue {

    interviewType = JobWorkerInterviewType;

    get interviewConfirmation(): AnonJobWorkerInterviewDto {
        return ContactAnonModule.interviewConfirmation;
    }

    get loading() {
        return ContactAnonModule.loading;
    }

    get isConfirmationSubmitted() {
        return ContactAnonModule.isJobInterviewConfirmationSubmitted;
    }
}
